module.exports = __webpack_public_path__ + "img/img-subir-menu.18ed4e7e.webp";